import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import "./rules";
import "core-js/stable";
import "regenerator-runtime/runtime";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

const app = createApp(App);
const pinia = createPinia();

// Sentry.init({
//   app,
//   dsn: "https://db582583168c45bcbb6d73d3aee327fc@o1362450.ingest.sentry.io/6653939",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["localhost", "miri-dev.e-bus.co.kr", /^\//],
//     }),
//   ],
//   tracesSampleRate: 1.0, // 0에서 1 사이의 숫자로 주어진 트랜잭션이 Sentry로 전송 될 확률을 제어
//   tracingOptions: {
//     // 하위 구성 요소를 추적하고 렌더링 프로세스에 대한 자세한 내용을 보기
//     trackComponents: true,
//   },
//   attachProps: true, // 로깅을 위해 모든 Vue 구성 요소의 props를 보기
// });

app.use(pinia).use(router);

router.isReady().then(() => {
  app.mount("#app");
});
